'use strict';

exports = module.exports = require('./dist')['default'];
exports['default'] = exports;
